import { ApexOptions } from 'apexcharts';
import { PrmClassroomCurriculumProgress } from 'types/schema-generated-types';

export const buildChartValues = (value: PrmClassroomCurriculumProgress) => {
  const completed = value.averageLessonCompletedCount;
  const assigned = value.averageLessonAssignedCount - value.averageLessonCompletedCount;
  const total = value.totalLessonCount - value.averageLessonAssignedCount;
  return [completed, assigned, total];
};

export const buildPieChartOptions = (value: PrmClassroomCurriculumProgress): ApexOptions => ({
  tooltip: {
    enabled: true,
    y: {
      // formatter: (data: any) => {
      //   return data; //value in tooltip
      // },
      title: {
        formatter: (seriesName: any) => {
          return seriesName === 'Total:' ? 'Remaining Total:' : seriesName;
        }
      }
    }
  },
  legend: {
    show: false
  },
  stroke: {
    lineCap: 'round'
  },
  dataLabels: {
    enabled: false
  },
  plotOptions: {
    pie: {
      donut: {
        size: '80%',
        labels: {
          show: true,
          name: {
            show: false
          },
          total: {
            show: true,
            showAlways: true,
            formatter: () => {
              return `${Math.trunc(
                (value.averageLessonCompletedCount / value.totalLessonCount) * 100
              )}%`;
            }
          }
        }
      }
    }
  },
  colors: ['#338AC6', '#338AC666', '#F4F4F4'],
  labels: ['Completed:', 'Assigned:', 'Remaining Total:']
});
